import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { 
  LayoutDashboard, 
  ArrowUpCircle, 
  Send, 
  ArrowDownCircle, 
  History 
} from 'lucide-react';

export function MobileNav() {
  const { t } = useLanguage();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/dashboard', label: t('nav.dashboard'), icon: LayoutDashboard },
    { path: '/topup', label: t('nav.topup'), icon: ArrowUpCircle },
    { path: '/transfer', label: t('nav.transfer'), icon: Send },
    { path: '/withdraw', label: t('nav.withdraw'), icon: ArrowDownCircle },
    { path: '/transactions', label: t('nav.transactions'), icon: History },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background border-t border-border pb-safe">
      <div className="flex items-center justify-around py-2">
        {navItems.map(({ path, label, icon: Icon }) => (
          <Link
            key={path}
            to={path}
            data-testid={`mobile-bottom-${path.slice(1)}`}
            className={`flex flex-col items-center gap-1 px-3 py-2 rounded-xl transition-colors ${
              isActive(path)
                ? 'text-primary'
                : 'text-muted-foreground'
            }`}
          >
            <Icon className={`h-5 w-5 ${isActive(path) ? 'text-primary' : ''}`} />
            <span className="text-[10px] font-medium">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
